var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Text, TextInput, StyleSheet } from 'react-native';
import styles from './Styles';
import { color } from '../Styles/Base';
import { isIOS } from '../Utils';
var CustomText = function (_a) {
    var _b = _a.selectable, selectable = _b === void 0 ? false : _b, style = _a.style, children = _a.children, props = __rest(_a, ["selectable", "style", "children"]);
    if (isIOS() && selectable) {
        return (React.createElement(TextInput, __assign({}, props, { style: [{ paddingTop: 0 }, styles.textStyle, style], editable: false, multiline: true, scrollEnabled: false }), children));
    }
    else {
        return (React.createElement(Text, __assign({}, props, { style: style }), children));
    }
};
var PartiText = function (_a) {
    var style = _a.style, children = _a.children, props = __rest(_a, ["style", "children"]);
    return (React.createElement(CustomText, __assign({}, props, { style: StyleSheet.flatten([styles.textStyle, { color: color.gray }, style]) }), children));
};
export default PartiText;
